import Env from '../base/env';
import Channels from '../base/channels';

export default () => ({
  async init() {
    this.events();
  },
  events() {
    Channels.on('close::navigation', () => {
      this.closeNavigation();
    });
  },
  closeNavigation() {
    Env.$html.classList.remove('nav-opened');
    // UI.revealNav.out();
    // Env.$html.classList.add('nav-leaving');
    // setTimeout(() => {
    //   Env.$html.classList.remove('nav-leaving');
    // }, 1100);
  },
  openNavigation() {
    Env.$html.classList.add('nav-opened');
    // UI.revealNav.in();
  },
  closePopin(item) {
    console.log(item);
  },
  addToCart() {
    Channels.emit('addtocart::click');
  },
  updateProductListView(status) {
    if (status) {
      Env.$html.classList.add('collection-altview');
    } else {
      Env.$html.classList.remove('collection-altview');
    }
    Channels.emit('scroll::soft::refresh');
  },
});
